"use strict";

const SuperError = require("super-error");

const BusbudError = SuperError.subclass("BusbudError");
BusbudError.asSafe = function asSafe() {
  this.safe = true;
  return this;
};

const errors = {
  BusbudError: BusbudError,
  library: {},
  codes: {}
};

const errorTypes = {
  T: "Top level error",
  U: "User error",
  O: "Operational error",
  E: "External error"
};
errors.errorTypes = errorTypes;

const systemParts = {
  GE: "Generic",
  CH: "Checkout",
  SH: "Search",
  BO: "Booking",
  IM: "Import"
};
errors.systemParts = systemParts;

errors.actionTypes = {
  error: "An event we can't recover from occurred.",
  retry: "Retry the last operation",
  correct: "Ask user to correct input he submitted"
};

errors.getByCode = function(code) {
  if (!(code in errors.codes)) throw new Error("There is no error with that error code");
  return errors.codes[code];
};

function makeError(
  code,
  type,
  part,
  default_action,
  name,
  default_message,
  user_visible,
  response_code,
  optional_fields,
  constructor_arguments
) {
  if (!(type in errorTypes)) throw new Error(type + " is not an existing error type.");
  if (!(part in systemParts)) throw new Error(part + " is not an existing system part.");

  let Parent = BusbudError;
  if (type === "U") Parent = errors.UserError;
  if (type === "O") Parent = errors.OperationalError;
  if (type === "E") Parent = errors.ExternalError;

  const parent_instance = new Parent();

  const errorConstructor = Parent.subclass(name, function(message, action) {
    this.message = default_message;
    this.actionType = default_action;
    if (constructor_arguments) {
      for (let i = 0; i < constructor_arguments.length; i++) {
        const name = constructor_arguments[i].name;
        this[name] = arguments[i];
      }
    } else {
      if (message) {
        this.message = message;
      }
      if (action) {
        this.action = action;
      }
    }

    this.errorCode = code;
    this.errorType = type;
    this.systemPart = part;
    this.code = response_code || parent_instance.code;
    this.userVisible =
      typeof user_visible === "undefined" ? parent_instance.userVisible : user_visible;
    this.asSafe = function asSafe() {
      this.safe = true;
      return this;
    };

    if (optional_fields) {
      const fieldNames = Object.keys(optional_fields);
      for (const i in fieldNames) {
        if (!this[fieldNames[i]]) {
          this[fieldNames[i]] = optional_fields[fieldNames[i]];
        }
      }
    }
  });
  errors.codes[code] = errorConstructor;
  errors[name] = errorConstructor;
  errors.library[name] = errorConstructor;
}

// Load errors from errors file
const all_errors = require("./errors_definitions");

all_errors.forEach(function(e) {
  makeError(
    e.code,
    e.type,
    e.part,
    e.action,
    e.name,
    e.message,
    e.user_visible,
    e.response_code,
    e.optional_fields,
    e.constructor_arguments
  );
});

/**
 * Export module for browsers and commonjs
 */
if (module && module.exports) {
  module.exports = errors;
}
if (typeof window === "object") {
  window.busbud = window.busbud || {};
  window.busbud.errors = errors;
}
